import { FilterEditorModalController } from './filter-editor-modal.component';

export class FilterEditorModalService {
  constructor($timeout, $modal) {
    this.$timeout = $timeout;
    this.$modal = $modal;
  }

  open(model, filter, asNew) {
    let updateModalSize = () => {
      $('.modal-body1').height((window.innerHeight * 0.96 -
      $('.modal-header').outerHeight() -
      $('.modal-footer').outerHeight() - 30));
      let baseheight = $('.modal-body1').height() - $('#myTab').height() - 10;
      $('.aggregate-modal').height(baseheight);
      $('.dimension-list').height(baseheight);
      $('.aggregate-box').height(baseheight - 10);
      $('.filter-filters-list').height(baseheight - 10);
      $('.aggregate-container-modal')
        .height(baseheight - 10 - $('.aggregate-header').height());
    };

    let filterModal = this.$modal.open({
      templateUrl: 'filterDialog.html',
      controller : FilterEditorModalController,
      resolve    : {
        asNew : () => asNew,
        filter: () => filter,
        model : () => model,
      },
      windowClass: 'filterDialog',
    });
    filterModal.opened
      .then(() => {
        this.$timeout(() => {
          updateModalSize();
        }, 100);
      })
      .catch((err) => {
        console.error(err);
      });
    return filterModal.result;
  };
}



// WEBPACK FOOTER //
// ./src/filter/editor/filter-editor-modal.service.js